import type { ReactNode } from "react";

interface Props {
  size?: number;
  color?: string;
  children: ReactNode;
}

export function Numeric({ size = 44, color = "var(--fg1)", children }: Props) {
  return (
    <div
      style={{
        fontFamily: "var(--font-display)",
        fontWeight: 800,
        fontSize: size,
        lineHeight: 1,
        color,
        fontVariantNumeric: "tabular-nums",
        letterSpacing: "-0.01em",
      }}
    >
      {children}
    </div>
  );
}
